import styled from "styled-components";

export const PageContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #030c13;
  display: flex;
  flex-direction: column; 
  margin: 0;
  padding: 0; 
  overflow: visible;
`;
